document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("contact_form");
  const message = document.getElementById("NewsletterMessage");
  const submitButton = form ? form.querySelector('button[type="submit"]') : null;
  const formState = document.getElementById("FormState");

  if (!form) return;

  // Handle server-side form submission results on page load
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.has('customer_posted');
  
  if (customerPosted || formState) {
    if (formState) {
      const success = formState.dataset.success === "true";
      const hasErrors = formState.dataset.hasErrors === "1";
      const errorType = formState.dataset.errorType;

      if (success) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput && emailInput.value) {
          addSubmittedEmail(emailInput.value);
        }
        
        showMessage("Thanks for signing up! Check your inbox for confirmation.", "success");
        form.reset();
      } else if (hasErrors) {
        if (errorType === "duplicate") {
          showMessage("You're already subscribed, star traveler!", "info");
        } else {
          showMessage("Hmm, something cosmic went wrong. Try again?", "error");
        }
      }
    } else if (customerPosted) {
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        addSubmittedEmail(emailInput.value);
      }
      
      showMessage("Thanks for signing up! Check your inbox for confirmation.", "success");
      form.reset();
    }
  }

  // Track submitted emails in session storage
  const getSubmittedEmails = () => {
    try {
      return JSON.parse(sessionStorage.getItem('newsletter_emails') || '[]');
    } catch {
      return [];
    }
  };
  
  const addSubmittedEmail = (email) => {
    try {
      const emails = getSubmittedEmails();
      if (!emails.includes(email.toLowerCase())) {
        emails.push(email.toLowerCase());
        sessionStorage.setItem('newsletter_emails', JSON.stringify(emails));
      }
    } catch {
      // sessionStorage not available, silently fail
    }
  };

  const DUPLICATE_PHRASES = [
    "already subscribed",
    "already been added",
    "has already been added",
    "has already been taken",
    "already exists",
    "you are already subscribed",
    "already on the list",
    "is already in our list"
  ];

  const VALIDATION_PHRASES = [
    "invalid email",
    "enter a valid",
    "can't be blank",
    "can't be empty",
    "isn't valid",
    "is invalid"
  ];

  let isHandlingCaptcha = false;
  
  const handleSubmit = async (e) => {
    // Allow form to submit naturally if handling CAPTCHA
    if (isHandlingCaptcha) {
      isHandlingCaptcha = false;
      return;
    }
    
    e.preventDefault();
    
    // Check if email was already submitted in this session
    const emailInput = form.querySelector('input[type="email"]');
    const email = emailInput ? emailInput.value.toLowerCase().trim() : '';
    
    if (email && getSubmittedEmails().includes(email)) {
      showMessage("You're already subscribed, star traveler!", "info");
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add("loading");
    }

    showMessage("Submitting...", "pending");

    const formData = new FormData(form);

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      let text = "";
      try {
        text = await response.text();
      } catch (errText) {
        console.warn("[Newsletter] Could not read response text:", errText);
      }

      const lower = text.toLowerCase();
      const containsAny = (phrases) => phrases.some(p => lower.includes(p));

      // Check for CAPTCHA requirement
      if (response.status === 400 && lower.includes("captcha")) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          addSubmittedEmail(emailInput.value);
        }
        
        showMessage("Verifying you're human...", "pending");
        
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove("loading");
        }
        
        isHandlingCaptcha = true;
        form.submit();
        return;
      }

      // Check for duplicate or validation errors
      if (containsAny(DUPLICATE_PHRASES)) {
        showMessage("You're already subscribed, star traveler!", "info");
      } else if (containsAny(VALIDATION_PHRASES)) {
        showMessage("Please enter a valid email address.", "error");
      } else if (response.ok) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          addSubmittedEmail(emailInput.value);
        }
        
        showMessage("Thanks for signing up! Check your inbox for confirmation.", "success");
        form.reset();
      } else {
        showMessage("Hmm, something cosmic went wrong. Try again?", "error");
      }
    } catch (err) {
      console.error("[Newsletter] Network error:", err);
      showMessage("Network issue — please try again in a moment.", "error");
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.classList.remove("loading");
      }
    }
  };
  
  form.addEventListener("submit", handleSubmit);

  function showMessage(text, type) {
    if (!message) return;

    message.textContent = text;
    message.className = `newsletter-message ${type} show`;

    // Auto-hide success and info messages
    if (["success", "info"].includes(type)) {
      setTimeout(() => {
        message.classList.add("fade-out");
        setTimeout(() => {
          message.textContent = "";
          message.className = "newsletter-message";
        }, 800);
      }, 4000);
    }
  }
});